export default __webpack_public_path__ + "static/media/3.118b8f21.png";